module.exports = __webpack_public_path__ + "static/projekt_indywidualny_e14-9e0145a98faa2ac01630bc1ff2f54565.jpg";